import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ContentSection } from './components/ContentSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { ResultsSection } from './components/ResultsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1476942910442417&ev=PageView&noscript=1" alt="" data-id="element-1" />

      <CountdownBar data-id="element-2" />

      <div className="pt-16" data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <ContentSection data-id="element-7" />
        <BeforeAfterSection data-id="element-8" />
        <ResultsSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <BonusSection data-id="element-11" />
        <PricingSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </div>

      <SocialProofPopup data-id="element-15" />
    </div>;
}